// FinOps 세그먼트 공용 조각 (2026-07-20 분해) — Collapse·날짜/리버킷/델타 유틸.
// 분해 배경: FinopsSection 이 964줄로 자라며 훅 순서 사고(React #310)까지 발생 —
// 세그먼트당 파일 하나, 공용은 여기 하나.
// 선택 기간의 모든 날짜 배열 — 차트 X축을 "데이터 있는 날"이 아니라 "선택 기간"으로.
// 빈 날을 건너뛰면 90일을 선택해도 축이 2주처럼 압축돼 기간감이 왜곡된다.
function allDates(from, to) {
  const out = [];
  const d = new Date(from + "T00:00:00Z");
  const end = new Date(to + "T00:00:00Z");
  while (d <= end) {
    out.push(d.toISOString().slice(0, 10));
    d.setUTCDate(d.getUTCDate() + 1);
  }
  return out;
}


// 일별 행을 주/월 단위로 합산 — 계기판 추이 토글용(2026-07-20). 주는 월요일 시작.
function rebucketDaily(rows, gran) {
  if (gran === "day") return rows;
  const keyOf = (d) => {
    if (gran === "month") return d.slice(0, 7);
    const dt = new Date(d + "T00:00:00Z");
    dt.setUTCDate(dt.getUTCDate() - ((dt.getUTCDay() + 6) % 7));
    return dt.toISOString().slice(0, 10);
  };
  const by = new Map();
  for (const r of rows) {
    const k = keyOf(r.date);
    const row = by.get(k) || { date: k, costKrw: 0, deductedNc: 0 };
    row.costKrw += r.costKrw;
    row.deductedNc += r.deductedNc;
    by.set(k, row);
  }
  return [...by.values()].sort((a, b) => (a.date < b.date ? -1 : 1));
}

// 직전 동일 길이 기간 대비 증감률(소수) — KpiCard deltaPct 규약.
function deltaPct(cur, prev) {
  if (prev == null || !prev) return null;
  return (cur - prev) / prev;
}

// 하위 세그먼트(2026-07-20) — 계기판(경고등·마진)과 캐시 효율(추이 분석)은 소비 방식이
// 달라 한 세로줄에 쌓으면 스크롤이 길어진다. TrendSection 의 세그먼트 패턴과 동일.

// 접이식 패널 (2026-07-20) — Panel 과 같은 시각 톤, 두괄식 화면에서 "근거"류
// 블록을 접어두는 용도. 계기판 세부 지표의 details 문법과 동일한 조작감.
export function Collapse({ title, action, children, defaultOpen = false }) {
  return (
    <details open={defaultOpen} className="group rounded-2xl bg-white shadow-[0_1px_2px_rgba(15,23,42,0.04),0_8px_24px_-12px_rgba(15,23,42,0.08)]">
      <summary className="flex cursor-pointer flex-wrap items-center justify-between gap-2 px-4 py-3.5 text-sm font-semibold text-ink-800 sm:px-5 [&::-webkit-details-marker]:hidden">
        <span>{title}</span>
        <span className="flex items-center gap-3 text-[12px] font-normal text-ink-400">
          {action}
          <span className="group-open:hidden">펼치기 ▾</span>
          <span className="hidden group-open:inline">접기 ▴</span>
        </span>
      </summary>
      <div className="px-4 pb-4 sm:px-5 sm:pb-5">{children}</div>
    </details>
  );
}

export { allDates, rebucketDaily, deltaPct };
